// extracted by mini-css-extract-plugin
export default {"roomBackground":"styles_roomBackground__iookv","transparent":"styles_transparent__uCESd"};